/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-filter[_ngcontent-%COMP%], .box-parent[_ngcontent-%COMP%] {\n  background: #FFFFFF;\n  padding: 1.5em 2em 20px 2em !important;\n  border-radius: 10px 10px 0 0;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.box-parent[_ngcontent-%COMP%] {\n  border-radius: 0 0 10px 10px; }\n\n.padding-left[_ngcontent-%COMP%] {\n  padding-left: 75px; }\n\n.backgroundCompany[_ngcontent-%COMP%] {\n  min-width: 220px;\n  padding: 0px 10px;\n  word-break: break-all; }\n\n.backgroundCompany[_ngcontent-%COMP%]:last-child {\n  margin: 0px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.scss.shim.ngstyle.js.pre-build-optimizer.js